import React from "react"
import { Navigate } from "react-router-dom"

/** Home renders the default view that users see. */
const Home = () => {
  // TODO: Dashboard
  return (
    <Navigate to="/observations?sort_by=timestamp&sort_order=DESC&solve_status=success" />
  )
}

export default Home
